import React from 'react';
import _ from 'lodash';
import { i18n } from 'next-i18next';
import appUtils from '../../../../../utils/appUtils';
import {
  formatAddedDays,
  formatTimezoneOffset,
} from '../../../../../lib/date-utils';

interface CalendarHeaderProps {
  timeZone?: string;
  now?: Date;
}

const CalendarHeader: React.FC<CalendarHeaderProps> = (props) => {
  const { now, timeZone } = props;
  const currentLocale = appUtils.getLocaleFromLang(i18n.language);
  const offset = formatTimezoneOffset(timeZone, now);
  let format = 'ddd M/D';
  if (currentLocale === 'ja') {
    format = 'M月D日 (ddd)';
  } else if (currentLocale === 'tw') {
    format = 'M月D日, ddd';
  } else if (currentLocale === 'es') {
    format = 'dd, D MMM';
  } else if (currentLocale === 'pt') {
    format = 'ddd, D \\d\\e MMM';
  } else if (currentLocale === 'ru') {
    format = 'ddd, D.M';
  }
  const days = _.map([0, 1, 2, 3], (i) => {
    const formattedDate = formatAddedDays(
      now,
      i,
      timeZone,
      format,
      currentLocale,
    );
    return (
      <td key={`cal-header-date${i}`} className="today text-center">
        {formattedDate}
      </td>
    );
  });
  return (
    <div className="cal-header">
      <table>
        <tbody>
          <tr>
            <td className="cal-timezone side text-center">{offset}</td>
            {days}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default CalendarHeader;
